var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.012 32.029"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.137 26.922L20.231 16.013 31.135 5.101a2.989 2.989 0 000-4.225 2.983 2.983 0 00-4.222 0L16.008 11.789 5.096.875a2.984 2.984 0 00-4.222 0A2.989 2.989 0 00.875 5.1l10.911 10.913L.877 26.929a2.989 2.989 0 000 4.225 2.983 2.983 0 004.222 0l10.909-10.916 10.907 10.91a2.988 2.988 0 004.222-4.226z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })));
}

export default SvgCloseIcon;